import * as React from 'react';

function SvgEmailIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#39BEF5" />
      <g clipPath="url(#email-icon_svg__clip0)" fill="#232340">
        <path d="M13.483 15.49a.73.73 0 001.032 0l5.65-5.65A.291.291 0 0020 9.346a1.148 1.148 0 00-.168-.012H8.168c-.057 0-.113.004-.169.012a.292.292 0 00-.164.496l5.65 5.65z" />
        <path d="M20.935 10.402a.106.106 0 00-.117.023l-3.617 3.616a.147.147 0 000 .207l2.942 2.942a.438.438 0 11-.618.619l-2.942-2.942a.147.147 0 00-.206 0l-1.242 1.242a1.604 1.604 0 01-2.268 0l-1.244-1.241a.146.146 0 00-.206 0L8.475 17.81a.437.437 0 01-.618-.62l2.942-2.94a.147.147 0 000-.207l-3.617-3.617a.106.106 0 00-.164.016A.106.106 0 007 10.5v7a1.167 1.167 0 001.167 1.167h11.666A1.167 1.167 0 0021 17.5v-7a.106.106 0 00-.065-.098z" />
      </g>
      <defs>
        <clipPath id="email-icon_svg__clip0">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgEmailIcon;
